export default function validateSummary(summaryText) {
  const errors = [];
  const warnings = [];
  const text = summaryText || '';
  
  if (!text.trim()) {
    errors.push("Professional summary is empty.");
  } else if (text.trim().length < 80) {
    warnings.push("Summary is too short. Try expanding to 2-3 sentences.");
  } else if (text.trim().length > 500) {
    warnings.push("Summary is a bit long. Keep it concise.");
  }

  const percentage = text.trim() ? (text.trim().length >= 80 ? 100 : 50) : 0;

  return {
    id: "summary",
    completed: errors.length === 0,
    percentage,
    errors,
    warnings
  };
}
